import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { TaskManagerService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Task } from '../../models'

const log = new Logger('TaskManagerDetailResolver')
@Injectable({ providedIn: 'root' })
export class TaskManagerDetailResolver implements Resolve<Observable<Task>> {
  constructor(
    private taskService: TaskManagerService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['tid']
    
    return this.taskService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/task-manager']))
    )
  }
}
